<template>
  <div>
    <Nav v-bind:organization="organization" />
    <div class="app">
      <Sidebar />
      <div id="organization_main_view">
          <div class="floating-container">
            <div class="floating-header">
              <h1>Organization Settings</h1>
            </div>
            <OrganizationSettingsForm v-bind:organization="organization" />
          </div>
          <div class="floating-container">
            <h1>Testing &amp; Analytics</h1>
            <p>
              To view and edit site testing strategies, click <router-link v-bind:to="`/organizations/me/testing/`">here</router-link> to go to the testing dashboard.
            </p>
          </div>
          <div class="floating-container">
            <div class="floating-header">
              <h1>Sites</h1>
              <button class="small" @click="addSite">+ Add Site</button>
            </div>
            <Table v-bind:head="head" v-bind:body="body" />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../css/main.css";
import "../css/components.css";

import request from "../js/request.js";
import utils from "../js/utils.js";

import Table from "./generics/Table";
import Sidebar from "./generics/Sidebar";
import Nav from "./generics/Nav";
import OrganizationSettingsForm from "./special/OrganizationSettingsForm";

import store from "@/js/store";

const { api_path } = utils;

const methods = {
  process: {
    sites: (sites, data) => sites.map(o => {
      return {
        key: o.public_key,
        data: [
          { name: "site_name", html: o.site_name, link: `/organizations/me/sites/${o.public_key}/` },
          { html: data.organization.organization_name },
          { html: `<code>${o.public_key}</code>` },
          { html: utils.formatTime(new Date(o.createdAt)) },
          { html: `<button>Delete</button>` },
        ],
      };
    }),
  },
};

export default {
  name: 'OrganizationMainView',
  data () {
    const data = {
      organization: {},
      head: [
        { name: "site_name", placeholder: "Site Name", html: "Site", width: 450 },
        { html: "Organization", width: 200 },
        { html: "Public Key", width: 350 },
        { html: "Created On", width: 100 },
        { html: "Actions", width: 100, align: "right" }
      ],
      body: [],
    };

    (async () => {
      const { organization, sites, statistics } = await utils.generalInformation();

      data.organization = organization;
      data.body = methods.process.sites(sites, data);
    })();

    return data;
  },

  methods: {
    addSite: (() => {
      let editing = false;
      return async function (e) {
        if (editing === false) {
          e.target.innerText = "Save Site";
          editing = true;
          this.$data.body.unshift({ empty: true });
        } else {
          let table = e.target.parentNode.nextElementSibling;
          let data = utils.getFormInput(table);

          if (data.site_name.length > 0) {
            let response = await request(`${api_path.pay}/organizations/me/sites/`, {
              headers: { Authorization: `Basic ${store.organization.auth_token}` }
            }).post(data);

            const { sites } = await utils.generalInformation({ update: ["sites"] });

            editing = false;
            e.target.innerText = "+ Add Site";

            this.$data.body = methods.process.sites(sites, this.$data);
          }
        }
      }
    })(),
  },

  mounted () {
    this.$on("edit", payload => {
      let { idx, name } = payload;
      let { body, head } = this.$data;

      console.log(body, idx);
      body[idx].data = body[idx].data.map((o, col_idx) => {
        return Object.assign(o, { edit: !!head[col_idx].name });
      });
      this.$data.body = body.map(o => o);
    });

    this.$on("save", async payload => {
      let { data, idx } = payload;
      let { sites } = await utils.generalInformation();

      let response = await request(`${api_path.pay}/organizations/me/sites/${sites[idx].public_key}`, {
        headers: { Authorization: `Basic ${store.organization.auth_token}` }
      }).put(data);

      const updated_sites = (await utils.generalInformation({ update: ["sites"] })).sites;

      this.$data.body = methods.process.sites(updated_sites, this.$data);
    });
  },

  components: {
    Table,
    OrganizationSettingsForm,
    Sidebar,
    Nav,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.app {
  text-align: center;
  margin-top: 20px;
}

#organization_main_view {
  display: inline-block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganizationMain.vue